const CustomOrderReviewStep = ({
  form,
  getCustomerLabel,
  getEventTypeLabel,
  getServiceTypeLabel,
  getDietaryPreferenceLabel,
  getbeverageTypeLabel,
  getpackageTypeLabel,
  reviewData,
}) => {
  return (
    <div className="max-h-[60vh] overflow-y-auto pr-2">
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm text-gray-600">Customer</span>
          <span className="text-red-500">*</span>
        </div>
        <div className="text-base font-medium">{getCustomerLabel()}</div>
      </div>

      <h3 className="text-base font-medium mb-4">Event Details</h3>

      <div className="bg-gray-50 rounded-lg p-4 space-y-3">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-xs text-gray-600">Event Date</span>
            <p className="text-sm font-medium">
              {form.getFieldValue("eventDate")
                ? form.getFieldValue("eventDate").format("YYYY-MM-DD") // Or any other desired format
                : "N/A"}
            </p>
          </div>
          <div>
            <span className="text-xs text-gray-600">Event Type</span>
            <p className="text-sm font-medium">
              {getEventTypeLabel() || "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-xs text-gray-600">Event Details</span>
            <p className="text-sm font-medium">
              {form.getFieldValue("eventDetails") || "N/A"}
            </p>
          </div>
          <div>
            <span className="text-xs text-gray-600">Contact Person</span>
            <p className="text-sm font-medium">
              {form.getFieldValue("contactPerson") || "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-xs text-gray-600">Guest Count</span>
            <p className="text-sm font-medium">
              {form.getFieldValue("guestCount") || "N/A"}
            </p>
          </div>
          <div>
            <span className="text-xs text-gray-600">Service Type</span>
            <p className="text-sm font-medium">
              {getServiceTypeLabel() || "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-xs text-gray-600">Venue</span>
            <p className="text-sm font-medium">
              {form.getFieldValue("venue") || "N/A"}
            </p>
          </div>
          <div>
            <span className="text-xs text-gray-600">Dietary Requirements</span>
            <p className="text-sm font-medium">
              {getDietaryPreferenceLabel() || "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-xs text-gray-600">Drinks</span>
            <p className="text-sm font-medium">
              {getbeverageTypeLabel() || "N/A"}
            </p>
          </div>
          <div>
            <span className="text-xs text-gray-600">Package Type</span>
            <p className="text-sm font-medium">
              {getpackageTypeLabel() || "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-xs text-gray-600">Customer Role</span>
            <p className="text-sm font-medium">
              {form.getFieldValue("customerRole") || "N/A"}
            </p>
          </div>
          <div>
            <span className="text-xs text-gray-600">Budget (per person)</span>
            <p className="text-sm font-medium">
              ₦
              {parseFloat(
                form.getFieldValue("budgetPerPerson") || 0
              ).toLocaleString()}
            </p>
          </div>
        </div>

        <div>
          <span className="text-xs text-gray-600">Food Request</span>
          <p className="text-sm font-medium whitespace-pre-wrap mt-1">
            {form.getFieldValue("foodRequest") || "N/A"}
          </p>
        </div>
      </div>
      <div className="mt-6 bg-orange-50 p-4 rounded-lg">
        <div className="flex justify-between mb-2">
          <span className="text-sm">Quote Amount:</span>
          <span className="text-sm font-medium">
            ₦
            {form.getFieldValue("quoteAmount")
              ? parseFloat(form.getFieldValue("quoteAmount")).toLocaleString()
              : "0"}
          </span>
        </div>
      </div>
      {/* <div className="mt-6 bg-orange-50 p-4 rounded-lg">
        <div className="flex justify-between mb-2">
          <span className="text-sm">Subtotal:</span>
          <span className="text-sm font-medium">
            ₦{reviewData.subtotal.toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between mb-3">
          <span className="text-sm">Discount:</span>
          <span className="text-sm font-medium">{reviewData.discount}</span>
        </div>
        <div className="flex justify-between mb-3">
          <span className="text-sm">Service Fee:</span>
          <span className="text-sm font-medium">
            {reviewData.serviceFeeText}
          </span>
        </div>
        <div className="flex justify-between pt-3 border-t border-orange-200">
          <span className="font-medium">Total Amount:</span>
          <span className="text-lg font-bold">
            ₦{reviewData.total.toLocaleString()}
          </span>
        </div>
      </div> */}
    </div>
  );
};
export default CustomOrderReviewStep;
